import { zoomInElement, zoomOutElement, fadeInElement, fadeOutElement } from '@/views/situationRoom/animation/zoomAndFade';
import { modalChartRenderers } from '@/views/situationRoom/utils/highCharts/modalFactories';
export default {
  name: 'InformationModal',
  props: {
    siteName: String,
    siteType: String,
    currentAnalysisChartData: Array
  },
  computed: {
    // TODO: 再優化
    chart0: function chart0() {
      return modalChartRenderers.solarInfo[0](this.currentAnalysisChartData[0]);
    },
    chart1: function chart1() {
      return modalChartRenderers.solarInfo[1](this.currentAnalysisChartData[1]);
    },
    chart2: function chart2() {
      return modalChartRenderers.solarInfo[2](this.currentAnalysisChartData[2]);
    },
    chart3: function chart3() {
      return modalChartRenderers.powerInfo[0](this.currentAnalysisChartData[0]);
    },
    chart4: function chart4() {
      return modalChartRenderers.powerInfo[1](this.currentAnalysisChartData[1]);
    },
    chart5: function chart5() {
      return modalChartRenderers.powerInfo[2](this.currentAnalysisChartData[2]);
    }
  },
  methods: {
    handleCloseModal: function handleCloseModal() {
      var _this = this;
      zoomOutElement(this.$refs.modalMain, 0.4);
      fadeOutElement(this.$refs.modalBk, 0.4, function () {
        _this.$emit('close-modal');
      });
    }
  },
  mounted: function mounted() {
    fadeInElement(this.$refs.modalBk, 0.4);
    zoomInElement(this.$refs.modalMain, 0.4);
  }
};